import React from 'react'
import parse from 'html-react-parser'
import { Grid, Paper, Typography, Button } from '@material-ui/core'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import Loader from '../Loader/Loader'
import { useStyles } from './AddFillInTheBlankStyles'

const FillInTheBlankTile = ({
  questionIndex,
  editQuestion,
  addQuestion,
  question,
  isPublished,
  isQuizStarted,
  quizStartTime,
  deleteQuestion,
  handleDelete,
  isWriteAllowed,
  handleChange,
}) => {
  const classes = useStyles()

  const quizStarted = isQuizStarted(quizStartTime)
  const isEditing = editQuestion === questionIndex || addQuestion
  const showMarks = Number.isNaN(editQuestion) && !addQuestion
  const canShowDelete = !quizStarted || !isPublished
  const isDeleting = deleteQuestion?.isLoading

  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item xs={10} sm={11}>
        <Paper elevation={2} variant="outlined" className={classes.paper}>
          <Grid item xs={12} className={classes.editQuestion}>
            <Grid container item xs={12}>
              <Grid item xs={7} sm={4}>
                <Typography className={classes.questionIndex}>
                  Question {(questionIndex ?? 0) + 1}.
                </Typography>
              </Grid>

              <Grid
                item
                xs={5}
                sm={8}
                container
                alignItems="center"
                justifyContent="flex-end"
              >
                {showMarks && (
                  <Typography
                    variant="h4"
                    className={classes.tileMarks}
                    style={{ color: '#00B7A4' }}
                  >
                    {question?.marks} marks
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} style={{ display: 'flex' }}>
                <div className={classes.question}>
                  {parse(question?.question)}
                </div>
              </Grid>

              <Typography
                className={classes.question}
                style={{ fontSize: '20px' }}
              >
                Correct Answers:
              </Typography>

              {question?.acceptedAnswers?.map(({ value }, index) => (
                <Grid item xs={12} key={`answer_${index}`}>
                  <Paper
                    elevation={2}
                    variant="outlined"
                    className={classes.isCorrect}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '8px',
                      marginBottom: '8px',
                    }}
                  >
                    <Grid container item xs={12} spacing={2}>
                      <Grid
                        item
                        container
                        xs={8}
                        sm={10}
                        md={10}
                        lg={10}
                        style={{ display: 'flex' }}
                        justifyContent="flex-start"
                      >
                        <Typography className={classes.selectedChoiceValue}>
                          {value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      {isWriteAllowed && !isEditing && (
        <Grid item xs={2} sm={1}>
          <Button
            color="secondary"
            variant="outlined"
            className={classes.editButton}
            onClick={handleChange}
            disabled={quizStarted}
          >
            <EditOutlinedIcon data-testid="question-testId" />
          </Button>

          {canShowDelete &&
            (isDeleting ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingTop: '12px',
                }}
              >
                <Loader size={30} />
              </div>
            ) : (
              <Button
                variant="outlined"
                className={classes.deleteButton}
                disabled={quizStarted}
                onClick={handleDelete}
                data-testid="delete-button-on-click"
              >
                <DeleteOutlineOutlinedIcon />
              </Button>
            ))}
        </Grid>
      )}
    </Grid>
  )
}

export default FillInTheBlankTile
